export default "__VITE_ASSET__B6PC5klp__"